import { endOfDay, isSameDay, startOfMonth, startOfWeek, sub } from 'date-fns'

const staticRangeHandler = {
  range: {},
  isSelected(range) {
    const definedRange = this.range()
    return (
      isSameDay(range.startDate, definedRange.startDate) &&
      isSameDay(range.endDate, definedRange.endDate)
    )
  },
}

const createStaticRanges = (ranges) => {
  return ranges.map((range) => ({ ...staticRangeHandler, ...range }))
}

export const datePickerRanges = createStaticRanges([
  {
    label: 'Last 90 Days',
    range: () => ({
      startDate: sub(endOfDay(new Date()), { days: 90 }),
      endDate: endOfDay(new Date()),
    }),
  },
  {
    label: 'Last 60 Days',
    range: () => ({
      startDate: sub(endOfDay(new Date()), { days: 60 }),
      endDate: endOfDay(new Date()),
    }),
  },
  {
    label: 'Last 30 Days',
    range: () => ({
      startDate: sub(endOfDay(new Date()), { days: 30 }),
      endDate: endOfDay(new Date()),
    }),
  },
  {
    label: 'Last 7 Days',
    range: () => ({
      startDate: sub(endOfDay(new Date()), { days: 7 }),
      endDate: endOfDay(new Date()),
    }),
  },
  {
    label: 'Month to Date',
    range: () => ({
      startDate: startOfMonth(new Date()),
      endDate: endOfDay(new Date()),
    }),
  },
  {
    label: 'Week to Date',
    range: () => ({
      startDate: startOfWeek(new Date()),
      endDate: endOfDay(new Date()),
    }),
  },
])

export const utcTimeZone = 'Europe/Berlin'
